import React from 'react';
import Lottie from 'lottie-react';
import styled from 'types/theme.types';
import LoaderAnimationData from 'assets/images/animations/env0-loader.json';

export const loaderSizes = ['default', 'small', 'large'] as const;
export type LoaderSize = (typeof loaderSizes)[number];

export const loaderTypes = ['default', 'robot'] as const;
export type LoaderType = (typeof loaderTypes)[number];

export interface LoaderProps {
  size?: LoaderSize;
  type?: LoaderType;
  name?: string;
}

const SIZE_MAP: { [key in LoaderSize]: string } = {
  large: '150px',
  default: '100px',
  small: '50px'
};

export const Loader: React.FunctionComponent<LoaderProps> = ({ size = 'default' as const, name = 'loader' }) => {
  const animation = { data: LoaderAnimationData, id: 'default' };

  return (
    <Container data-e2e={name}>
      <AnimationContainer size={size} data-e2e={`animation-container-${size}`}>
        <Lottie animationData={animation.data} data-e2e={`animation-${animation.id}`} loop autoPlay />
      </AnimationContainer>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AnimationContainer = styled.div<{ size: LoaderSize }>`
  height: ${({ size }) => SIZE_MAP[size]};
  width: ${({ size }) => SIZE_MAP[size]};
`;

export default Loader;
